module.exports = __webpack_public_path__ + "static/media/VG.25ef1016.png";